import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "redux/reducers";
import { Action } from "redux";
import { SSOProvider } from "api/entities/account";
import { accountThunkActions } from "redux/actions/account";
import { connect } from "react-redux";
import Button from "components/shared-ui/button";
import React from "react";
import styles from "./auth-buttons.module.scss";

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => ({
    redirectToLoginSSO: (ssoProvider: SSOProvider, redirectUri: string) =>
        dispatch(accountThunkActions.redirectToSSOLogin(ssoProvider, redirectUri)),
});

interface IMicrosoftAuthButtonProps
    extends ReturnType<typeof mapDispatchToProps> {

    redirectUri: string;
    buttonText?: string;
    onClick?: () => void;
}

export function MicrosoftIcon() {
    return (
        <span className={styles["microsoft-icon"]}>
          <svg className="fabric-1f68ir3-svg" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
            <path xmlns="http://www.w3.org/2000/svg" d="M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"></path>
          </svg>
        </span>
    );
}

export const MicrosoftAuthButton = connect(null, mapDispatchToProps)((props: IMicrosoftAuthButtonProps) => {
    return (
        <Button
            colors="primary"
            onClick={() => {
                props.redirectToLoginSSO(SSOProvider.Microsoft, props.redirectUri)

                if (!!props.onClick) {
                    props.onClick();
                }
            }}
            testId="button-sign-up">
                <MicrosoftIcon />

            {props.buttonText ?? "Log in with Microsoft"}
        </Button>
    );
});